module.exports = __webpack_public_path__ + "add7d299797f1d1b3b088c4acddec8d1.svg";